import useModalStore from '@/store/use-modal-store'

const Modal = () => {
    const { isVisible, content } = useModalStore()

    if (!isVisible || !content) return null // Do not render an empty overlay that can block clicks
    return (
        <>
            <div
                role="dialog"
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                aria-modal="true"
                className="fixed inset-0 z-50 bg-gray-900 bg-opacity-50 flex justify-center items-center">
                {/* Modal Content */}
                <div>{content}</div>
            </div>
        </>
    )
}

export default Modal
